module.exports = __webpack_public_path__ + "img/bold-delete.ddd6e5a5.svg";